<!--献策车道div-->
<template>
    <div id="suggestDiv">
        <img src="../../assets/suggest.png">
        <div>
            <span>献策车道</span>
            <p>Suggestions</p>
        </div>
    </div>
</template>
<script>
export default {
  name: "suggestDiv",
  methods:{
    test(){
      alert(1)
    }
  }
};
</script>
<style lang="scss" scoped>
#suggestDiv {
  height: 164px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    180deg,
    #4e54c8 0%,
    #8f94fb 100%
  );
  border-radius: 3px;
  div {
    text-align: center;
  }
  img{
      width: 48px;
      height: 48px;
      margin-right: 25px;
  }
  span{
    font-weight: 700;
    font-size: 36px;
    letter-spacing: 6px;
    color: #FFFFFF;
  }
  p{
    padding-top: 2px;
    opacity: 0.5;
    font-family: 'Arial Normal', 'Arial';
    font-style: normal;
    font-size: 18px;
    color: #F5F5F5;
  }
}
</style>

